import React from "react";
import PropTypes from "prop-types";
import { MrbListPage, MrbPageContentHeader } from "mrb/components/layout";
import { MrbTable } from "mrb/components/table";
import { MrbQuerySearchInput } from "mrb/components/input";
import { MrbSelect } from "mrb/components/select";
import { MrbButton } from "mrb/components/button";
import { TableNoDataOverlay } from "common/components";
import { defaultTemplate } from "common/hoc";

function LoadioDeviceListTemplate({ loadioDeviceListViewStore, t }) {
    const {
        gridStore,
        queryUtility,
        batchProfileSelectStore,
        applyBatchProfile,
        canApplyBatch,
        hasSelection,
        selectedCount,
    } = loadioDeviceListViewStore;

    return (
        <MrbListPage store={loadioDeviceListViewStore} t={t}>
            <MrbPageContentHeader classNameOverride="u-mar--bottom--sml">
                <div className="u-display--flex u-gap--sml f--align--items--center">
                    <MrbQuerySearchInput queryUtility={queryUtility} />
                    {hasSelection && batchProfileSelectStore && (
                        <div className="u-display--flex u-gap--sml f--align--items--center u-mar--left--med">
                            <div className="f--shrink--0 f--basis--250">
                                <MrbSelect
                                    t={t}
                                    store={batchProfileSelectStore}
                                    classNameExtend="c-dropdown--dark c-dropdown--sml"
                                    styles={{
                                        valueContainer: (base) => ({ ...base, overflow: "visible" }),
                                        singleValue: (base) => ({ ...base, overflow: "visible" }),
                                    }}
                                />
                            </div>
                            <MrbButton
                                t={t}
                                onClick={applyBatchProfile}
                                disabled={!canApplyBatch}
                                label="ADMINISTRATION.LOADIO_DASHBOARD.DEVICES.BATCH.SAVE_BUTTON"
                                className="c-btn c-btn--base c-btn--primary"
                            />
                            <span className="u-type--med u-type--color--secondary">
                                {t("ADMINISTRATION.LOADIO_DASHBOARD.DEVICES.BATCH.SELECTED_COUNT", {
                                    count: selectedCount,
                                })}
                            </span>
                        </div>
                    )}
                </div>
            </MrbPageContentHeader>
            <MrbTable
                t={t}
                tableStore={gridStore}
                className="ag-theme-alpine u-mar--bottom--sml"
                emptyStateRender={TableNoDataOverlay}
            />
        </MrbListPage>
    );
}

LoadioDeviceListTemplate.propTypes = {
    loadioDeviceListViewStore: PropTypes.object.isRequired,
    t: PropTypes.func,
};

export default defaultTemplate(LoadioDeviceListTemplate);
